export const DigitalMarketingMenuList = [
    {
        title: "Dashboard",
        iconStyle: imagepaths.Dashboard,
        iconActive: imagepaths.DashboardActive,
        to: "/app/digitalmarketinghome",
        id: ["digitalmarketinghome"],
    },
];
